let parser;

/**
 * Converts an HTML string to an element.
 * @param  {String} string The string to convert.
 * @param  {String} ParserConstructor Constructor to create parser from.
 * @return {Element}
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 */
const stringToHTML = (string, ParserConstructor = window.DOMParser) => {
    if (!ParserConstructor || !string) {
        return;
    }

    parser = parser || new ParserConstructor();

    const parseResult = parser.parseFromString(string, 'text/xml');

    if (parseResult.querySelector('parsererror')) {
        return;
    }

    return parseResult.firstElementChild;
};

module.exports = stringToHTML;
